import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Caption1Strong, Spinner } from '@fluentui/react-components';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DatasetSectionGroup from './DatasetSectionGroup';
import DatasetList from './DatasetList';
import {
  MenuItemNotInteractive,
  SectionHeaderButton,
  SectionHeaderContainer,
  SectionHeaderGroupHeader,
} from './styling';
import DataLoaderContext from '../../../../contexts/DataLoaderContext';

function DatasetSection({
  isLoading,
  favoriteDatasets,
  strippedDatasets,
  onDatasetLoadClick,
  onFavoriteClick,
  openDataLoader,
}) {
  const { setTrigger } = useContext(DataLoaderContext);
  
  // During loading
  if (isLoading) return <Spinner size="small" />;

  const openManageFavoriteFilter = () => {
    setTrigger('Dropdown');
    openDataLoader('manage', { currentFilter: 'favorite' });
  };

  const openManageAllFilter = () => {
    setTrigger('Dropdown');
    openDataLoader('manage', { currentFilter: '' });
  };

  return (
    <>
      {!!favoriteDatasets.length && (
        <DatasetSectionGroup
          sectionHeader={
            <SectionHeaderContainer>
              <SectionHeaderGroupHeader>
                <FormattedMessage
                  id="loadData.menu.item.datasets.favorite.title"
                  defaultMessage="Favorites"
                />
              </SectionHeaderGroupHeader>
              <SectionHeaderButton
                appearance="subtle"
                size="small"
                icon={<ChevronRightIcon fontSize="small" />}
                iconPosition="after"
                onClick={openManageFavoriteFilter}
              >
                <FormattedMessage
                  id="loadData.menu.item.datasets.favorite.more"
                  defaultMessage="More"
                />
              </SectionHeaderButton>
            </SectionHeaderContainer>
          }
        >
          <DatasetList
            datasets={favoriteDatasets}
            onDatasetLoadClick={onDatasetLoadClick}
            onFavoriteClick={onFavoriteClick}
          />
        </DatasetSectionGroup>
      )}
      <DatasetSectionGroup
        sectionHeader={
          <SectionHeaderContainer>
            <SectionHeaderGroupHeader>
              <FormattedMessage
                id="loadData.menu.item.datasets.recent.title"
                defaultMessage="Most recent"
              />
            </SectionHeaderGroupHeader>
            <SectionHeaderButton
              appearance="subtle"
              size="small"
              icon={<ChevronRightIcon fontSize="small" />}
              iconPosition="after"
              onClick={openManageAllFilter}
            >
              <FormattedMessage id="loadData.menu.item.datasets.recent.all" defaultMessage="All" />
            </SectionHeaderButton>
          </SectionHeaderContainer>
        }
      >
        {strippedDatasets.length ? (
          <DatasetList
            datasets={strippedDatasets}
            onDatasetLoadClick={onDatasetLoadClick}
            onFavoriteClick={onFavoriteClick}
          />
        ) : (
          <MenuItemNotInteractive>
            <Caption1Strong>
              <FormattedMessage
                id="loadData.menu.item.datasets.recent.empty"
                defaultMessage="No recent data sets found"
              />
            </Caption1Strong>
          </MenuItemNotInteractive>
        )}
      </DatasetSectionGroup>
    </>
  );
}

DatasetSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  favoriteDatasets: PropTypes.arrayOf(PropTypes.object).isRequired,
  strippedDatasets: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDatasetLoadClick: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
  openDataLoader: PropTypes.func.isRequired,
};

export default DatasetSection;
